import { all, fork } from "redux-saga/effects";
import userSaga from "./features/user/userSaga";
import billerSaga from "./features/billers/billerSaga";
import billerDetailSaga from "./features/billerDetails/billerDetailSaga";
import { billPaymentWatcher } from "./bbps/billPayment/billPaymentSaga";
import { billValidationWatcher } from "./bbps/billValidation/billValidationSaga";
import { billFetchWatcher } from "./bbps/billFetch/billFetchSaga";
import { billerPlansWatcher } from "./bbps/billerPlans/billerPlanSaga";
import { razorpaySaga } from "./paymentGateway/razorpay/razorpaySaga";
import { billerRegionsSaga } from "./bbps/billerRegions/billerRegionsSaga";
import walletSaga from "./wallet/walletSaga";
import { transactionsSaga } from "./userTransaction/userTransactionSaga";
import bbpsComplaintSaga from "./bbps/Complaint/bbpsComplaintSaga";

export default function* rootSaga() {
  yield all([
    fork(userSaga),
    walletSaga(),
    fork(billerSaga),
    fork(billerDetailSaga),
    fork(billerPlansWatcher),
    fork(billValidationWatcher),
    fork(billPaymentWatcher),
    fork(billFetchWatcher),
    fork(razorpaySaga),
    fork(billerRegionsSaga),
    fork(transactionsSaga),
    fork(bbpsComplaintSaga),
  ]);
}
